import { computed, defineComponent } from 'vue'
import type { IDataTableHeadProps } from './types'
import { DataRow } from '../data-row'

export const DataHead = defineComponent<IDataTableHeadProps & { borderlessTop?: boolean }>(
  (props) => {
    const rows = computed(() => props.rows)
    return () => {
      return (
        <thead class="bg-gray-100 z-10 top-0 left-0 sticky">
          {rows.value.map((row, i) => {
            return <DataRow row={row as unknown as any} table={props.table} borderlessTop={props.borderlessTop} borderless={props.borderless} disableSorting={props.disableSorting} head key={`${i}`} />
          })}
        </thead>
      )
    }
  },
  { props: ['rows', 'borderless', 'table', 'disableSorting', 'borderlessTop'] }
)
